import { Doc } from '@dadohr/shared/domainTypes/document';
import { IExperienceTemplate } from '@dadohr/shared/domainTypes/experience';

// A subtask's parent task isn't stored directly on the instance error — it's
// found by matching `subtaskTplId` against the block ids on each task
// template. Shared so grouping (`computeGroupKey` in types.ts) and display
// (`timelineItem` in collectors/instanceSubtask.ts) always agree on which
// task an error belongs to.
export const findParentTaskTemplate = (tpl: Doc<IExperienceTemplate>, subtaskTplId: string) =>
  tpl.data.tasks.find((t) => t.blocks.map((b) => b.id).includes(subtaskTplId));
